import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=dfa50458&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=dfa50458&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._iyputc2ruckis4av77ubvklewu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa50458",
  null
  
)

export default component.exports